const OutcomeCard = ({ label, desc }) => (
  <article className="flex gap-3">
    <span className="flex-none w-6 h-6 rounded-full bg-secondary text-primary grid place-items-center text-[11px] font-extrabold">
      ✓
    </span>
    <div>
      <strong className="text-xl text-[#1E2027]">{label}</strong>
      <p className="text-[#565656] text-[16px] leading-relaxed mt-1">{desc}</p>
    </div>
  </article>
);

const LearningModelCard = ({ icon, title, desc }) => (
  <article className="flex gap-3">
    <span className="flex-none w-6 h-6 rounded-full bg-secondary text-primary grid place-items-center text-[11px] font-extrabold">
      ✓
    </span>
    <div className="text-[#565656] text-[16px] leading-relaxed">
      <strong className="block text-[#1E2027] text-xl mb-1">{title}</strong>
      {desc}
    </div>
  </article>
);

const CourseDescriptionSection = ({ selectedCourseData }) => {
  return (
    <section id="description" className="bg-white pt-8">
      <div className="border border-[#DFE6F7] rounded-[26px] bg-white shadow-course-card mb-8 p-6 md:p-9">
        <h2 className="text-primary font-bold text-3xl md:text-5xl tracking-tight mb-5">
          Course Description
        </h2>
        {selectedCourseData?.descriptionHeading && (
          <h3 className="text-[#1E2027] text-xl md:text-2xl font-semibold mb-3">
            {selectedCourseData.descriptionHeading}
          </h3>
        )}
        <p className="text-[#565656] max-w-[760px] text-sm md:text-xl leading-relaxed">
          {selectedCourseData?.description}
        </p>
        {selectedCourseData?.heroHighlights?.length > 0 && (
          <ul className="grid sm:grid-cols-2 gap-x-6 gap-y-3 mt-6">
            {selectedCourseData.heroHighlights.map((highlight, i) => (
              <li
                key={i}
                className="flex items-start gap-2.5 text-sm font-bold bg-hire-tint-blue rounded-full px-3 py-2 text-primary leading-snug"
              >
                {highlight}
              </li>
            ))}
          </ul>
        )}
        {selectedCourseData?.keyOutcomes?.length > 0 && (
          <>
            {selectedCourseData?.keyOutcomesHeading && (
              <h3 className="text-[#1E2027] text-lg md:text-2xl font-semibold mt-9 mb-5">
                {selectedCourseData.keyOutcomesHeading}
              </h3>
            )}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-5 bg-[#F0F5FF] rounded-2xl p-6">
              {selectedCourseData.keyOutcomes.map((outcome) => (
                <OutcomeCard
                  key={outcome.label}
                  label={outcome.label}
                  desc={outcome.desc}
                />
              ))}
            </div>
          </>
        )}
        {selectedCourseData?.learningModels?.length > 0 && (
          <div className="border-t border-[#DFE6F7] mt-8 pt-8">
            <h3 className="text-[#1E2027] text-lg md:text-xl font-semibold mb-2">
              {selectedCourseData?.learningModelsHeading}
            </h3>
            <p className="text-[#565656] text-xl">
              {selectedCourseData?.learningModelsSubtitle || (
                <>
                  A {selectedCourseData?.duration || "hands-on"} experiential
                  learning journey built around the way modern product teams
                  actually work.
                </>
              )}
            </p>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-5 mt-6">
              {selectedCourseData.learningModels.map((model) => (
                <LearningModelCard
                  key={model.modelId}
                  icon={model.modelIcon}
                  title={model.modelTitle}
                  desc={model.modelDescription}
                />
              ))}
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default CourseDescriptionSection;
